<template>
  <div class="personnelList app-container">
    <template>
      <QueryForm
        ref="QueryForm"
        v-model="formInline"
        :select-item="selectItem"
        @onSearch="getData"
        @batchAllot="batchAllot"
      />
      <DataTable
        ref="table"
        :list="list"
        :table-height="tableHeight"
        :loading="tableLoading"
        :select-item="selectItem"
        @handleSelectionChange="handleSelectionChange"
      />
      <BasePagination
        :total="total"
        :page-size="formInline.pageSize"
        :form="formInline"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </template>
    <AllotDialog
      v-model="allotDialogForm"
      :dialog-visible="allotDialogVisi"
      :type="allotType"
      :submit-loading="allotSubmitLoading"
      @formOnSubmit="allotSubmit"
      @close="allotDialogVisi = false"
    />
  </div>
</template>

<script>
import QueryForm from './components/QueryForm.vue'
import DataTable from './components/Table.vue'
import { queryPersonImportDetail } from '@/api/user'
import mixins from '@/mixins/index'
import { mapState } from 'vuex'
import AllotDialog from '@/views/personnel-list/components/personnel-list/components/AllotDialog.vue'
import {
  personBatchUpdate,
  queryPersonAgreementLastPullInfo,
  queryPullPersonTaskDetail,
  getImportWhiteListLogInfoDetail,
  getImportBankCardDetail,
  queryBlacklistImportDetail
} from '@/api/personnel'
import { formatIdCard } from '@/utils/index'
export default {
  components: { QueryForm, DataTable, AllotDialog },
  mixins: [mixins],
  props: {
    selectItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      minusHeight: 400,
      formInline: {
        pageSize: 20,
        pageNumber: 1,
        time: '',
        personName: '',
        idcardNumber: '',
        teamName: '',
        workerTypeName: '',
        jobNumber: '',
        personPhotoStatus: '',
        recordStatus: '',
        type: 'ADD',
        photoName: '',
        personType: '',
        licensePlate: '',
        devicePersonCode: ''
      },
      total: 0,
      tableLoading: false,
      list: [],
      allotDialogForm: {},
      allotDialogVisi: false,
      allotSubmitLoading: false,
      allotType: 1
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.formInline.time) {
        this.formInline.startTime = this.formInline.time[0]
        this.formInline.endTime =
          this.formInline.time[1].split(' ')[0] + ' 23:59:59'
      } else {
        delete this.formInline.startTime
        delete this.formInline.endTime
      }
      if (this.formInline.gudRespTime) {
        this.formInline.gudRespStartTime = this.formInline.gudRespTime[0]
        this.formInline.gudRespEndTime =
          this.formInline.gudRespTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        delete this.formInline.gudRespStartTime
        delete this.formInline.gudRespEndTime
      }
      this.tableLoading = true
      let method = queryPersonImportDetail
      if (this.selectItem.taskType === 'ZQXY_PERSON_PULL') {
        method = queryPersonAgreementLastPullInfo
      }
      if (this.selectItem.taskType === 'VERIFY_DEVICE_PULL_PERSON') {
        method = queryPullPersonTaskDetail
      }
      if (this.selectItem.taskType === 'WHITELIST_IMPORT') {
        method = getImportWhiteListLogInfoDetail
      }
      if (this.selectItem.taskType === 'BANK_CARD_IMPORT') {
        method = getImportBankCardDetail
      }
      if (this.selectItem.taskType === 'BLACKLIST_IMPORT') {
        method = queryBlacklistImportDetail
      }
      method({
        businessId: this.projectItem.projectId,
        projectId: this.projectItem.projectId,
        taskId: this.selectItem.taskId,
        ...this.formInline
      })
        .then((res) => {
          res.data.records.forEach((element) => {
            element.personPhotoPath =
              process.env.VUE_APP_OSS_DOMAIN + '/' + element.personPhotoPath
            element.idcardNumber = formatIdCard(element.idcardNumber)
          })
          this.list = res.data.records
          this.total = res.data.total
          this.$refs.table.getInstance().bodyWrapper.scrollTop = 0
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    handleSizeChange(e) {
      this.formInline.pageSize = e
      this.getData()
    },
    handleCurrentChange(e) {
      this.formInline.pageNumber = e
      this.getData()
    },
    addNewData() {
      this.formData = {}
      this.type = 1
      this.addDialogVisible = true
    },
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.personId)
    },
    batchAllot(type) {
      if (!this.ids || this.ids.length <= 0) {
        this.$message.warning('请选择要操作的人员！')
        return
      }
      console.log(type)
      this.allotType = type
      this.allotDialogVisi = true
    },
    allotSubmit() {
      this.allotSubmitLoading = true
      const form = {
        personIds: this.ids,
        projectId: this.projectItem.projectId
      }
      if (this.allotType === 1) {
        form.companyId = this.allotDialogForm.companyId
        form.teamId = this.allotDialogForm.teamId
      } else {
        form.workerTypeId = this.allotDialogForm.workerTypeId
      }
      personBatchUpdate(form)
        .then((res) => {
          this.$message.success(res.message)
          this.getData()
          this.allotDialogVisi = false
        })
        .finally(() => {
          this.allotSubmitLoading = false
        })
    }
  }
}
</script>

<style scoped>
.personnelList {
  background: #fff;
}
</style>

